import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Card from '../Card/Card';
import Input from '../Shared/Input';
import FormOverlapStyles from './FormOverlap.styled';
import Button from '../Shared/Button';
import noop from '../../util/noop';
import { useInView } from 'react-intersection-observer';
import MessageSuccess from '../Shared/Icons/MessageSuccess';

const FormOverlap = ({
  fields = [],
  onSubmit = noop,
  isSubmitted,
  successMessage = '',
  isAnimated = true,
  className = '',
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const initialValues = fields.reduce((_validationSchema, fieldset) => {
    fieldset.rows.map(row => {
      row.map(
        field =>
          (_validationSchema = {
            ..._validationSchema,
            [field.name]: field?.initialValues || '',
          })
      );
    });

    return _validationSchema;
  }, {});
  const validationSchema = fields.reduce((_validationSchema, fieldset) => {
    fieldset.rows.map(row => {
      row.map(
        field =>
          (_validationSchema = {
            ..._validationSchema,
            [field.name]: field.validationSchema,
          })
      );
    });

    return _validationSchema;
  }, {});

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    errors,
    touched,
    values,
    status,
    isSubmitting,
    setFieldValue,
    validateForm,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape(validationSchema),
    onSubmit,
  });

  useEffect(() => {
    validateForm();
  }, []);

  return (
    <FormOverlapStyles
      ref={ref}
      className={`block-form_overlap ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <div className='inner'>
        <Card>
          {!isSubmitted && (
            <form onSubmit={handleSubmit}>
              {status && (
                <div className='errors'>
                  <h3>{status?.title}</h3>
                  <ul>
                    {status.errors &&
                      Object.keys(status.errors).map(key => (
                        <li>{status.errors[key]}</li>
                      ))}
                  </ul>
                </div>
              )}
              {fields.map(({ title = '', rows = [] }) => (
                <fieldset disabled={isSubmitting} key={title}>
                  <legend className='type-h4'>{title}</legend>

                  {rows.map((rowFields, i) => (
                    <div className='row' key={i}>
                      {rowFields.map(({ validationSchema, name, ...props }) => (
                        <Input
                          {...props}
                          key={name}
                          name={name}
                          value={values?.[name]}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors?.[name]}
                          touched={touched?.[name]}
                          setFieldValue={setFieldValue}
                        />
                      ))}
                    </div>
                  ))}
                </fieldset>
              ))}
              <Button type='submit' fullwidth className={className}>
                Submit
              </Button>
            </form>
          )}
          {isSubmitted && <MessageSuccess />}
          {isSubmitted && <p>{successMessage}</p>}
        </Card>
      </div>
    </FormOverlapStyles>
  );
};

FormOverlap.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.required,
        label: PropTypes.string,
        type: PropTypes.oneOf([
          'text',
          'number',
          'dropdown',
          'textarea',
          'date',
        ]),
        className: PropTypes.string,
      })
    )
  ),
  onSubmit: PropTypes.func,
  isSubmitted: PropTypes.bool,
  successMessage: PropTypes.string,
  isAnimated: PropTypes.bool,
};

export default FormOverlap;
